var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_c('com-mheader',{on:{"menushow":_vm.menuShow}}),_c('router-view'),_c('com-mfooter'),(_vm.menu)?_c('com-mmenu',{on:{"menuclose":_vm.menuClose}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }